export default __webpack_public_path__ + "static/IMG_8203-55dd9653d54ca50261442de32b14e348.jpeg";